export function enableBody() {
    document.body.style.overflow = 'unset'
    document.body.style.touchAction = 'unset'
}
export function disableBody(){
    document.body.style.overflow = 'hidden'
    document.body.style.touchAction = 'none'
}